// src/pages/ApplicationChampionshipSeason/shared/steps/Step1Info/SeasonFormatField.tsx
import { FunctionComponent } from 'react';
import { Box, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SeasonType } from '@/model';
import { SeasonFormData } from '../../schemas';
import { InfoCallout } from '../../components/InfoCallout';
import { SeasonFormatOption } from './SeasonFormatOption';

const PREFIX = 'pages.application_season.components.season_step1.fields.format';

const OPTIONS: { value: SeasonType; key: string }[] = [
  { value: SeasonType.LEAGUE, key: 'league' },
  { value: SeasonType.KNOCKOUT, key: 'cup' },
  { value: SeasonType.HYBRID, key: 'hybrid' },
];

type SeasonFormatFieldProps = {
  /** Quando true, desabilita os radios e exibe um callout explicativo. */
  isLocked?: boolean;
};

export const SeasonFormatField: FunctionComponent<SeasonFormatFieldProps> = ({
  isLocked = false,
}) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext<SeasonFormData>();

  return (
    <Box>
      <Text fontWeight="medium" mb={2}>
        {t(`${PREFIX}.label`)}
      </Text>

      {isLocked ? (
        <Box mb={3}>
          <InfoCallout>{t(`${PREFIX}.locked_callout`)}</InfoCallout>
        </Box>
      ) : null}

      <Controller
        control={control}
        name="season_type"
        render={({ field }) => (
          <RadioGroup
            value={field.value ?? ''}
            isDisabled={isLocked}
            onChange={next => field.onChange(next as SeasonType)}
          >
            <Stack spacing={3}>
              {OPTIONS.map(option => (
                <SeasonFormatOption
                  key={option.value}
                  value={option.value}
                  title={t(`${PREFIX}.${option.key}.label`)}
                  help={t(`${PREFIX}.${option.key}.help`)}
                  isSelected={field.value === option.value}
                />
              ))}
            </Stack>
          </RadioGroup>
        )}
      />

      {errors.season_type ? (
        <Text fontSize="13px" color="red.500" mt={2}>
          {errors.season_type.message}
        </Text>
      ) : null}
    </Box>
  );
};
